import ChatBubbleRoundedIcon from '@mui/icons-material/ChatBubbleRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CircleIcon from '@mui/icons-material/Circle';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import { ListItemDecorator, MenuItem, Stack, Typography } from '@mui/joy';
import { TNotification } from '../../../../redux/services/notifications/getNotifications';

const NotificationIcon = (props: { type: string }) => {
  switch (props.type) {
    case 'comment':
      return <ChatBubbleRoundedIcon color="primary" />;
    case 'informational':
      return <InfoRoundedIcon color="primary" />;
    case 'confirmation':
      return <CheckRoundedIcon color="primary" />;
    default:
      return <NotificationsRoundedIcon color="primary" />;
  }
};

export type NotificationDropdownItemProps = {
  item: TNotification;
  disabled: boolean;
  onClick?: () => void;
};

export const NotificationDropdownItem = (
  props: NotificationDropdownItemProps
) => {
  const { item, onClick, disabled } = props;

  const date = new Date(item.timestamp);
  const formattedDate = date.toLocaleDateString('nl-NL', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <MenuItem
      sx={{
        maxWidth: '95vw',
      }}
      onClick={onClick}
      disabled={disabled}
    >
      <ListItemDecorator>
        <NotificationIcon type={item.type} />
      </ListItemDecorator>
      <Stack direction={'column'}>
        <Stack direction={'row'} gap={1}>
          {item.readStatus ? null : (
            <CircleIcon
              sx={{ fontSize: '.5rem', marginTop: '.45rem' }}
              color="primary"
            />
          )}
          <Typography level="body-md">{item.title}</Typography>
        </Stack>
        <Typography level="title-sm">{item.content}</Typography>
        <Typography level="title-sm">{formattedDate}</Typography>
      </Stack>
    </MenuItem>
  );
};
